// API configuration for MerchMint

const API_CONFIG = {
  endpoint: process.env.REACT_APP_API_ENDPOINT || 'https://xv16s0m4ic.execute-api.us-east-1.amazonaws.com/prod',
};

/**
 * Submit a quote request to the backend
 * @param {Object} formData - The quote form data
 * @returns {Promise<Object>} - The API response
 */
export const submitQuoteRequest = async (formData) => {
  const response = await fetch(`${API_CONFIG.endpoint}/quote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to submit quote request');
  }

  return response.json();
};

export default API_CONFIG;
